import { memo } from "react";
import { useHandleTextFieldChange } from "services/forms/hooks";
import { TextArea } from "ui/components/TextField/TextArea";
import { InvoiceNotesProps } from "./types";

const InvoiceNotes: React.FC<InvoiceNotesProps> = ({ formValues, setFormValues }) => {
    const handleTextFieldChange = useHandleTextFieldChange(setFormValues, formValues);

    return (
        <div className="mt-3">
            <TextArea
                name="note"
                label="Napomena (vidljivo kupcu)"
                value={formValues.note}
                onChange={handleTextFieldChange}
            />
        </div>
    );
};

export default memo(InvoiceNotes);
